export default {
  methods: {

    roundNumber (number, decimals = 2) {
      const factor = Math.pow(10, decimals)
      const shifted = Math.abs(number) * factor
      // Compensate for floating point: PHP's round() treats values like 31676.9249999... as 31676.925
      const epsilon = shifted * Number.EPSILON * 2

      return Math.sign(number) * Math.floor(shifted + 0.5 + epsilon) / factor
    },

    taxAmount (grossPrice, businessTax, VAT = 12, transactionType) {
      if (['Vatable'].includes(businessTax) && ['With-2307'].includes(transactionType)) {
        const taxAmount = Number(grossPrice) - (Number(grossPrice) * (100 / (100 + Number(VAT))))
        // console.log('TAX AMOUNT', originalTaxAmount, roundedTaxAmount)

        return this.roundNumber(taxAmount)
      }

      return 0.00
    },

    taxableAmount (grossPrice, taxAmount, businessTax, transactionType) { // netPrice
      if (['Vatable'].includes(businessTax) && ['With-2307'].includes(transactionType)) {
        const taxableAmount = Number(grossPrice) - Number(taxAmount)
        // console.log('TAXABLE AMOUNT', originalTaxableAmount, roundedTaxableAmount)

        return this.roundNumber(taxableAmount)
      }

      // return Number(['With-2307'].includes(transactionType) ? grossPrice : 0.00).toFixed(2)
      return grossPrice
    },

    withHoldingTax (taxableAmount, percentage, taxStatus, transactionType) {
      if (['Liable'].includes(taxStatus) && ['With-2307'].includes(transactionType)) {
        const withHoldingTax = Number(taxableAmount) * (Number(percentage) / 100)
        // console.log('WITH HOLDING TAX', originalWithHoldingTax, roundedWithHoldingTax)

        return this.roundNumber(withHoldingTax)
      }

      return 0.00
    },

    amountDue (grossPrice, withHoldingTax) {
      const amountDue = Number(grossPrice) - Number(withHoldingTax)
      // console.log('AMOUNT DUE', originalAmountDue, roundedAmountDue)

      return this.roundNumber(amountDue)
    },

    vatCalculator (grossPrice, businessTax, taxStatus, percentage, transactionType = 'Without-2307') {
      const taxAmount = this.taxAmount(grossPrice || 0.00, businessTax, 12, transactionType)
      const taxableAmount = this.taxableAmount(grossPrice || 0.00, taxAmount, businessTax, transactionType)
      const withHoldingTax = this.withHoldingTax(taxableAmount, percentage, taxStatus, transactionType)
      const amountDue = this.amountDue(grossPrice || 0.00, withHoldingTax, transactionType)

      return {
        taxAmount: taxAmount,
        taxableAmount: taxableAmount,
        withHoldingTax: withHoldingTax,
        amountDue: amountDue
      }
    }
  }
}
